import type { InfoCardProps } from "@components/InfoCardProps.js";
import type { Tenant } from "@core/schema/Tenant.js";

export function getHowWeDevMobileApps(tenant: Tenant): InfoCardProps[] {
	return [
		{
			desc: `Úvodní konzultace a analýza`,
		},
		{
			desc: "Návrh a prototyp",
		},
		{
			desc: "Vývoj a implementace",
		},
		{
			desc: "Testování na reálných zařízeních a spuštění",
		},
		{
			desc: "Distribuce aplikace na Google Play a App Store",
		},
		{
			desc: "Podpora a údržba po dokončení aplikace",
		},
	];
}
